import { Container, Card, Row, Col, Spinner, Form } from "react-bootstrap"
import { useState } from "react"
// import { useParams } from "react-router-dom"
import { useCallback, useEffect } from "react"
import { useSelector } from 'react-redux';
import AddRole from "../roles/AddRole";
import RoleCard from '../roles/RoleCard';


export default function RolesCard() {

  const [isCollapsed, setIsCollapsed] = useState(true)

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  const url = process.env.REACT_APP_URL;
  // const meetingId = useParams().meetingId;

  const [isLoading, setIsLoading] = useState(true);
  const [roles, setRoles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { user: authUser } = useSelector(x => x.auth);

  const getRoles = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${url}/meetingRoles`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      setRoles(data);
    } catch (e) {
      console.log(`Roles component - Get Roles error: ${e}`);
    }
    setIsLoading(false);
  }, [url]);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredRoles = roles.filter(role =>
    role.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Sort roles by name before mapping
  const sortedRoles = filteredRoles.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Container>
      <Card id="timer" className="mb-3 mt-3">
        <Card.Header onClick={toggleCollapse} style={{ cursor: 'pointer', paddingTop: '5px' }}>
          <Row className="header mb-2">
            <Col xs={11} className="title">
              <h5>Meeting Roles</h5>
            </Col>
            <Col xs={1} lg={1}>
              <i className={`bi ${isCollapsed ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
            </Col>
          </Row>
        </Card.Header>
        {!isCollapsed && (
          isLoading ?
            <Spinner animation="border" variant="danger" />
            :
            <>
              <Card.Body className="to-left">
                <Container className="">
                  {/* <div className='fixed-wrapper'> */}
                  <Row className='header mb-2 '>
                    {(authUser && authUser.user.acl === 'Officer') &&
                      <Col xs={12} lg={12} key={'newRole'}>
                        <AddRole getRoles={getRoles} />
                      </Col>
                    }
                  </Row>
                  <Row className='mb-3'>
                    <Col xs={12} lg={12}>
                      <Form.Control
                        type="text"
                        placeholder="Search for a role..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        data-bs-theme={'dark'}
                      />
                    </Col>
                  </Row>
                  {/* </div> */}
                  <Row className="events-list">
                    {sortedRoles.map(role => (
                      <Col xs={12} lg={12} key={role._id} className='mb-2'>
                        <RoleCard role={role} getRoles={getRoles} />
                      </Col>
                    ))}
                  </Row>
                </Container>
              </Card.Body>
              <Card.Footer>
                <Row>
                  <Col xs={12} lg={12}>
                    <p className="float-end">Meeting Roles</p>
                  </Col>
                </Row>
              </Card.Footer>
            </>
        )}
      </Card>
    </Container>
  )
}